import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchACQ134CompanySize } from './branches/BranchACQ134CompanySize';
import { BranchACQ134VariantA } from './branches/BranchACQ134VariantA';
import { BranchACQ134VariantB } from './branches/BranchACQ134VariantB';
import { BranchMarketingMicroapps } from './branches/BranchMarketingMicroapps';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchCookielessWordpress } from './branches/BranchCookielessWordpress';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.Marketing]: [...softwareSignupBranches, BranchMarketingMicroapps, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.Service]: [...softwareSignupBranches, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches],
  [Flow.Integrations]: [BranchCookielessWordpress]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};